interface HeatmapProps {
  rows: string[]                  // rótulos das linhas (ex.: meses de cohort)
  cols: (string | number)[]       // rótulos das colunas (ex.: 0,1,2… meses)
  values: (number | null)[][]     // values[linha][coluna]; null = célula vazia
  max?: number                    // valor que mapeia para intensidade máxima (default 100)
  formatValue?: (v: number) => string
  baseColor?: [number, number, number] // RGB base (default emerald-400)
}

export default function Heatmap({
  rows,
  cols,
  values,
  max = 100,
  formatValue = v => `${Math.round(v)}`,
  baseColor = [52, 211, 153],
}: HeatmapProps) {
  const [r, g, b] = baseColor
  const cell = (v: number | null) => {
    if (v == null) return { background: 'transparent', text: '' as string }
    const alpha = Math.max(0.06, Math.min(1, v / max))
    return { background: `rgba(${r}, ${g}, ${b}, ${alpha})`, text: formatValue(v) }
  }

  return (
    <div className="overflow-x-auto">
      <table className="border-separate" style={{ borderSpacing: 3 }}>
        <thead>
          <tr>
            <th className="text-[10px] text-ink-faint font-normal pr-2"></th>
            {cols.map((c, i) => (
              <th key={i} className="text-[10px] text-ink-faint font-normal px-1 text-center min-w-[34px]">{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((rowLabel, ri) => (
            <tr key={ri}>
              <td className="text-[10px] text-ink-muted pr-2 whitespace-nowrap text-right">{rowLabel}</td>
              {cols.map((_, ci) => {
                const c = cell(values[ri]?.[ci] ?? null)
                return (
                  <td key={ci} className="p-0">
                    <div
                      className="h-7 min-w-[34px] rounded flex items-center justify-center text-[10px] tabular-nums text-white/90"
                      style={{ background: c.background }}
                      title={c.text}
                    >
                      {c.text}
                    </div>
                  </td>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
